import React from 'react';
import { motion } from 'framer-motion';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Countdown from 'react-countdown';
import { useLanguage } from '../contexts/LanguageContext';

const Hero = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get('code');
  const { language, t } = useLanguage();
  
  const onRSVPClick = () => {
    const currentPath = window.location.pathname;
    const basePath = currentPath.startsWith('/es') ? '/es' : '';
    
    if (invitationCode) {
      navigate(`${basePath}/rsvp?code=${invitationCode}`);
    } else {
      navigate(`${basePath}/rsvp`);
    }
  };

  const weddingDate = new Date('March 28, 2026 20:30:00 GMT-03:00');

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div className="text-center">
          <h3 className="mb-4">🎉 {language === 'es' ? '¡Hoy es nuestro día de boda!' : 'Today is Our Wedding Day!'} 🎉</h3>
          <p className="lead">{language === 'es' ? '¡Gracias por ser parte de nuestro día especial!' : 'Thank you for being part of our special day!'}</p>
        </div>
      );
    }

    return (
      <div className="countdown-container">
        <div className="countdown-grid">
          <div className="countdown-item">
            <div className="countdown-number">{days}</div>
            <div className="countdown-label">{t('hero.countdown.days')}</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{hours}</div>
            <div className="countdown-label">{t('hero.countdown.hours')}</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{minutes}</div>
            <div className="countdown-label">{t('hero.countdown.minutes')}</div>
          </div>
          <div className="countdown-item">
            <div className="countdown-number">{seconds}</div>
            <div className="countdown-label">{t('hero.countdown.seconds')}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="home" className="hero-section d-flex align-items-center justify-content-center text-center text-white">
      <motion.div 
        className="hero-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.div 
          className="announcement-badge mb-4 mb-lg-5"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <span className="badge-text">{t('hero.subtitle')}</span>
        </motion.div>
        
        <motion.h1 
          className="display-3 display-md-4 display-lg-2 display-xl-1 fw-bold mb-4 mb-lg-5"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          {t('hero.title')}
        </motion.h1>
        
        <motion.div 
          className="wedding-date mb-4 mb-lg-5"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <h2 className="h3">{t('hero.date')}</h2>
        </motion.div>
        
        <motion.div 
          className="hero-buttons mb-4 mb-lg-5"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1 }}
        >
          <button className="btn btn-outline-light btn-lg btn-sm me-3" onClick={onRSVPClick}>
            {t('hero.rsvpButton')}
          </button>
          
        </motion.div>

        {/* Countdown Section */}
        <motion.div 
          className=""
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.2 }}
        >
          <Countdown date={weddingDate} renderer={countdownRenderer} />
        </motion.div>
      </motion.div>
      <div className="hero-overlay"></div>
    </section>
  );
};

export default Hero;
